/**
 * LensDirect-style mobile cart card — view-details label + ellipsis manage menu.
 * Mobile only (≤749px); no-op on desktop.
 */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  window.__ciwExpressAnchorPassed = false;
  window.__ciwExpressLocation = 'header';

  function syncDetailsLabel(details) {
    if (details.classList.contains('ciw-frame-cart__details')) return;
    var summary = details.querySelector('.ciw-ld-cart-details__toggle');
    if (!summary) return;
    if (!mq.matches) {
      details.open = true;
      return;
    }
    summary.textContent = details.open ? '- Hide Details' : '+ View details';
  }

  function closeMenu(menu) {
    var trigger = menu.querySelector('.ciw-ld-cart-menu__trigger');
    var panel = menu.querySelector('.ciw-ld-cart-menu__panel');
    if (!trigger || !panel) return;
    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  }

  function closeAllMenus(except) {
    document.querySelectorAll('.ciw-ld-cart-menu').forEach(function (menu) {
      if (menu !== except) closeMenu(menu);
    });
  }

  function bindDetails(root) {
    if (!mq.matches) return;
    (root || document).querySelectorAll('.ciw-ld-cart-details:not([data-ciw-ld-bound])').forEach(function (details) {
      details.setAttribute('data-ciw-ld-bound', 'true');
      syncDetailsLabel(details);
      details.addEventListener('toggle', function () {
        syncDetailsLabel(details);
      });
    });
  }

  function bindMenus(root) {
    if (!mq.matches) return;
    (root || document).querySelectorAll('.ciw-ld-cart-menu:not([data-ciw-ld-bound])').forEach(function (menu) {
      menu.setAttribute('data-ciw-ld-bound', 'true');
      var trigger = menu.querySelector('.ciw-ld-cart-menu__trigger');
      var panel = menu.querySelector('.ciw-ld-cart-menu__panel');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        closeAllMenus(menu);
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
      });
    });
  }

  var pendingRemoveWrap = null;
  var removeInProgress = false;

  function getRemoveSheets() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ciw-cart-remove-sheet]'));
  }

  function getRemoveSheet() {
    var sheets = getRemoveSheets();
    return sheets.length ? sheets[sheets.length - 1] : null;
  }

  function ensureRemoveSheetPortal() {
    var sheets = getRemoveSheets();
    var sheet = sheets.length ? sheets[sheets.length - 1] : null;
    if (!sheet) return null;

    sheets.forEach(function (node, index) {
      if (index < sheets.length - 1) node.remove();
    });

    if (sheet.parentNode !== document.body) {
      document.body.appendChild(sheet);
    }
    return sheet;
  }

  function closeRemoveSheet() {
    getRemoveSheets().forEach(function (sheet) {
      sheet.classList.remove('is-open');
      sheet.hidden = true;
    });
    document.body.classList.remove('ciw-cart-remove-sheet-open');
    pendingRemoveWrap = null;
  }

  function openRemoveSheet(wrap) {
    if (removeInProgress) return;
    var sheet = ensureRemoveSheetPortal();
    if (!sheet || !wrap) return;
    var titleEl = sheet.querySelector('[data-ciw-cart-remove-title]');
    var subtitleEl = sheet.querySelector('[data-ciw-cart-remove-subtitle]');
    var subtitleTextEl = sheet.querySelector('[data-ciw-cart-remove-subtitle-text]');
    var stockDotEl = sheet.querySelector('[data-ciw-cart-remove-stock-dot]');
    var title = wrap.getAttribute('data-remove-title') || '';
    var subtitle = wrap.getAttribute('data-remove-subtitle') || '';
    var showStockDot = wrap.getAttribute('data-remove-subtitle-dot') === 'true';
    if (titleEl) {
      titleEl.textContent = title;
      titleEl.classList.toggle('ciw-cart-remove-sheet__title--wrap', wrap.getAttribute('data-remove-title-wrap') === 'true');
    }
    if (subtitleEl && subtitleTextEl) {
      if (subtitle) {
        subtitleTextEl.textContent = subtitle;
        subtitleEl.hidden = false;
      } else {
        subtitleTextEl.textContent = '';
        subtitleEl.hidden = true;
      }
    }
    if (stockDotEl) {
      stockDotEl.hidden = !showStockDot || !subtitle;
    }
    pendingRemoveWrap = wrap;
    sheet.hidden = false;
    window.requestAnimationFrame(function () {
      sheet.classList.add('is-open');
    });
    document.body.classList.add('ciw-cart-remove-sheet-open');
    closeAllMenus();
  }

  function removeCartLine(lineKey, line, wrap) {
    if (!lineKey && !line) return Promise.resolve();

    var cartItemsEl =
      (wrap && wrap.closest('cart-items')) || document.querySelector('cart-items');

    if (cartItemsEl && lineKey && typeof cartItemsEl.removeLineWithLinkedItems === 'function') {
      return cartItemsEl.removeLineWithLinkedItems(lineKey, line, '', '');
    }

    if (cartItemsEl && typeof cartItemsEl.updateQuantity === 'function') {
      return cartItemsEl.updateQuantity(lineKey || line, 0, '', '', line);
    }

    if (!lineKey) return Promise.resolve();

    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig()
        : {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            }
          };

    return fetch(
      changeUrl,
      Object.assign({}, config, {
        credentials: 'same-origin',
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
    )
      .then(function (response) {
        if (!response.ok) throw new Error('cart change failed');
        return response.text();
      })
      .then(function (state) {
        return JSON.parse(state);
      })
      .then(function (parsedState) {
        if (
          cartItemsEl &&
          parsedState &&
          parsedState.sections &&
          typeof cartItemsEl.renderCartSections === 'function'
        ) {
          cartItemsEl.renderCartSections(parsedState);
        } else {
          return requestCartSections();
        }
        if (window.CIW_CART_SYNC && typeof window.CIW_CART_SYNC.syncHeaderFromCart === 'function') {
          window.CIW_CART_SYNC.syncHeaderFromCart(parsedState);
        }
        return parsedState;
      });
  }

  function refreshCartDom() {
    var cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl && typeof cartItemsEl.refreshCartSectionsFromServer === 'function') {
      return cartItemsEl.refreshCartSectionsFromServer();
    }
    return requestCartSections();
  }

  function confirmRemoveFromSheet() {
    if (removeInProgress) return;

    var wrap = pendingRemoveWrap;
    if (!wrap) return;

    var lineKey = wrap.getAttribute('data-line-key');
    var line = wrap.getAttribute('data-index');
    var cartItemsEl = document.querySelector('cart-items');
    pendingRemoveWrap = null;
    removeInProgress = true;
    closeRemoveSheet();

    var row = document.getElementById('CartItem-' + line);
    if (row) row.classList.add('ciw-cart-line-removing');

    if (!cartItemsEl || !lineKey || typeof cartItemsEl.removeLineWithLinkedItems !== 'function') {
      removeInProgress = false;
      window.location.reload();
      return;
    }

    cartItemsEl
      .removeLineWithLinkedItems(lineKey, line, '', '')
      .then(function () {
        return cartItemsEl.refreshCartSectionsFromServer();
      })
      .then(function () {
        bind(document);
        scheduleExpressMount();
        updateCheckoutStickyState();
      })
      .catch(function () {
        window.location.reload();
      })
      .finally(function () {
        removeInProgress = false;
      });
  }

  function getCheckoutSticky() {
    return document.querySelector('[data-ciw-checkout-sticky]');
  }

  function ensureCheckoutStickyPortal() {
    var stickies = document.querySelectorAll('[data-ciw-checkout-sticky]');
    if (!stickies.length) return null;

    var sticky = stickies[stickies.length - 1];
    stickies.forEach(function (node) {
      if (node !== sticky) node.remove();
    });

    if (sticky.parentNode !== document.body) {
      document.body.appendChild(sticky);
    }

    return sticky;
  }

  function getStickyExpressAnchor() {
    return document.querySelector('[data-ciw-sticky-express-anchor]');
  }

  function getExpressMounts() {
    return {
      headerMount: document.querySelector('[data-ciw-express-mount]'),
      stickyMount: document.querySelector('[data-ciw-express-sticky-mount]'),
      headerCard: document.querySelector('.ciw-ld-express-checkout')
    };
  }

  function applyExpressLocation(useSticky) {
    if (!mq.matches) {
      return;
    }

    var target = useSticky ? 'sticky' : 'header';
    var mounts = getExpressMounts();
    var headerMount = mounts.headerMount;
    var stickyMount = mounts.stickyMount;
    var headerCard = mounts.headerCard;
    var buttons = document.querySelector('.cart__dynamic-checkout-buttons');

    if (!buttons || !headerMount || !stickyMount) {
      window.__ciwExpressLocation = 'header';
      if (headerCard) headerCard.hidden = false;
      if (stickyMount) stickyMount.hidden = true;
      return;
    }

    var buttonsInSticky = stickyMount.contains(buttons);
    var buttonsInHeader = headerMount.contains(buttons);
    var locationMatches =
      window.__ciwExpressLocation === target &&
      ((target === 'sticky' && buttonsInSticky) || (target === 'header' && buttonsInHeader));

    if (locationMatches) {
      if (headerCard) headerCard.hidden = target === 'sticky';
      stickyMount.hidden = target !== 'sticky';
      return;
    }

    window.__ciwExpressLocation = target;

    if (target === 'sticky') {
      if (headerCard) headerCard.hidden = true;
      stickyMount.hidden = false;
      stickyMount.appendChild(buttons);
      remountAcceleratedCheckoutCart(stickyMount);
    } else {
      if (headerCard) headerCard.hidden = false;
      stickyMount.hidden = true;
      headerMount.appendChild(buttons);
      remountAcceleratedCheckoutCart(headerMount);
    }

    delete buttons.dataset.ciwExpressReady;
    reinitExpressCheckout();
  }

  function resetCheckoutStickyState() {
    var sticky = getCheckoutSticky();
    if (sticky) {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    }
    window.__ciwExpressAnchorPassed = false;
    applyExpressLocation(false);
  }

  function updateCheckoutStickyState() {
    if (!document.body.classList.contains('template-cart') || !mq.matches) {
      resetCheckoutStickyState();
      return;
    }

    var sticky = ensureCheckoutStickyPortal();
    var checkoutAnchor = document.querySelector('[data-ciw-checkout-anchor]');
    if (!sticky || !checkoutAnchor) {
      resetCheckoutStickyState();
      return;
    }

    var checkoutRect = checkoutAnchor.getBoundingClientRect();
    var topCheckoutVisible = checkoutRect.bottom > 0 && checkoutRect.top < window.innerHeight;
    var showSticky = !topCheckoutVisible;

    sticky.classList.toggle('is-visible', showSticky);
    sticky.setAttribute('aria-hidden', showSticky ? 'false' : 'true');

    var expressAnchor = getStickyExpressAnchor();
    if (expressAnchor) {
      var expressRect = expressAnchor.getBoundingClientRect();
      if (expressRect.top <= window.innerHeight * 0.92) {
        window.__ciwExpressAnchorPassed = true;
      } else if (expressRect.top > window.innerHeight + 24) {
        window.__ciwExpressAnchorPassed = false;
      }
    } else {
      window.__ciwExpressAnchorPassed = false;
    }

    if (!showSticky) {
      window.__ciwExpressAnchorPassed = false;
    }

    var anchorBtn = checkoutAnchor.querySelector('.ciw-cart-mobile-checkout-btn');
    var stickyBtn = sticky.querySelector('.ciw-cart-mobile-checkout-btn');
    if (anchorBtn && stickyBtn) {
      stickyBtn.disabled = anchorBtn.disabled;
    }

    applyExpressLocation(showSticky && window.__ciwExpressAnchorPassed === true);
  }

  function bindCheckoutSticky() {
    updateCheckoutStickyState();

    if (window.__ciwCheckoutStickyScrollBound) return;
    window.__ciwCheckoutStickyScrollBound = true;

    var ticking = false;
    function onScrollOrResize() {
      if (!mq.matches) return;
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        updateCheckoutStickyState();
      });
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
  }

  function bindRemoveSheet() {
    var sheet = ensureRemoveSheetPortal();
    if (!sheet || sheet.dataset.ciwRemoveSheetBound) return;
    sheet.dataset.ciwRemoveSheetBound = 'true';

    sheet.addEventListener('click', function (event) {
      var closeTarget = event.target.closest('[data-ciw-cart-remove-close]');
      if (closeTarget) {
        event.preventDefault();
        closeRemoveSheet();
        return;
      }

      var confirmTarget = event.target.closest('[data-ciw-cart-remove-confirm]');
      if (confirmTarget) {
        event.preventDefault();
        confirmRemoveFromSheet();
      }
    });
  }

  function bindRemoveConfirm(root) {
    if (!mq.matches) return;
    (root || document).querySelectorAll('.ciw-frame-cart__remove:not([data-ciw-remove-bound])').forEach(function (wrap) {
      wrap.setAttribute('data-ciw-remove-bound', 'true');
      var btn = wrap.querySelector('.ciw-frame-cart__remove-btn');
      if (!btn || btn.dataset.ciwRemoveBound) return;
      btn.dataset.ciwRemoveBound = 'true';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openRemoveSheet(wrap);
      });
    });
  }

  function reinitExpressCheckout() {
    forceExpressCheckoutHorizontal();
    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }
    window.setTimeout(forceExpressCheckoutHorizontal, 100);
    window.setTimeout(forceExpressCheckoutHorizontal, 800);
  }

  function forceExpressCheckoutHorizontal() {
    if (!mq.matches) return;

    document.querySelectorAll('.ciw-cart-express-buttons').forEach(function (express) {
      express.querySelectorAll('.wallet-cart-grid').forEach(function (grid) {
        grid.classList.add('wallet-cart-grid--horizontal');
      });
    });
  }

  function remountAcceleratedCheckoutCart(scope) {
    (scope || document).querySelectorAll('shopify-accelerated-checkout-cart').forEach(function (el) {
      var fresh = document.createElement('shopify-accelerated-checkout-cart');
      Array.prototype.forEach.call(el.attributes, function (attr) {
        fresh.setAttribute(attr.name, attr.value);
      });
      el.replaceWith(fresh);
    });
  }

  function getExpressCheckoutButtons() {
    var mounts = [
      document.querySelector('[data-ciw-express-mount]'),
      document.querySelector('[data-ciw-express-sidebar-mount]'),
      document.querySelector('[data-ciw-express-sticky-mount]'),
      document.querySelector('[data-ciw-express-desktop-mount]')
    ];

    for (var i = 0; i < mounts.length; i += 1) {
      var mount = mounts[i];
      if (!mount) continue;
      var buttons = mount.querySelector('.cart__dynamic-checkout-buttons');
      if (buttons) return buttons;
    }

    return document.querySelector('.cart__dynamic-checkout-buttons');
  }

  function clearExpressMount() {
    if (!mq.matches) return;
    var mounts = [
      document.querySelector('[data-ciw-express-mount]'),
      document.querySelector('[data-ciw-express-desktop-mount]'),
      document.querySelector('[data-ciw-express-sticky-mount]')
    ];

    mounts.forEach(function (mount) {
      if (mount) mount.innerHTML = '';
    });
    window.__ciwExpressLocation = 'header';
    window.__ciwExpressAnchorPassed = false;
  }

  function scheduleExpressMount() {
    window.clearTimeout(window.__ciwExpressMountTimer);
    window.__ciwExpressMountTimer = window.setTimeout(function () {
      mountExpressCheckout();
      window.clearTimeout(window.__ciwExpressMountRetryTimer);
      window.__ciwExpressMountRetryTimer = window.setTimeout(function () {
        mountExpressCheckout();
      }, 600);
    }, 50);
  }

  function getCartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url) ? window.routes.cart_update_url : '/cart/update';
  }

  function getSectionIds() {
    var ids = [];
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');

    if (itemsEl && itemsEl.dataset.id) ids.push(itemsEl.dataset.id);
    if (footerEl && footerEl.dataset.id) ids.push(footerEl.dataset.id);

    return ids;
  }

  function parseSectionHtml(sectionHtml) {
    return new DOMParser().parseFromString(sectionHtml, 'text/html');
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function hitDiscountUrl(url) {
    var discountUrl = url;
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      var root = window.Shopify.routes.root;
      if (url.charAt(0) === '/') {
        discountUrl = root.replace(/\/?$/, '') + url;
      }
    }

    return fetch(discountUrl, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow'
    }).catch(function () {
      return null;
    });
  }

  function clearShopifyDiscountViaIframe() {
    return new Promise(function (resolve) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root.replace(/\/?$/, '/') + 'discount/';
      var iframe = document.createElement('iframe');
      var done = false;

      function finish() {
        if (done) return;
        done = true;
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        resolve();
      }

      iframe.setAttribute('aria-hidden', 'true');
      iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
      iframe.onload = function () {
        window.setTimeout(finish, 500);
      };
      iframe.onerror = finish;
      window.setTimeout(finish, 3000);
      iframe.src = url;
      document.body.appendChild(iframe);
    }).then(function () {
      return delay(300);
    });
  }

  function clearShopifyDiscount() {
    return hitDiscountUrl('/discount/')
      .then(function () {
        return delay(400);
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        if (!cartHasFirst30Discount(cart)) return cart;
        return clearShopifyDiscountViaIframe().then(function () {
          return delay(300);
        }).then(fetchCart);
      });
  }

  function postCartUpdate(payload) {
    var config = typeof fetchConfig === 'function'
      ? fetchConfig()
      : {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        };

    return fetch(getCartUpdateUrl(), Object.assign({}, config, {
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })).then(function (response) {
      if (!response.ok) throw new Error('cart update failed');
      return response.json();
    });
  }

  function buildSectionRequest() {
    var sectionIds = getSectionIds();
    if (!sectionIds.length) return {};

    return {
      sections: sectionIds,
      sections_url: window.location.pathname
    };
  }

  function renderCartSections(sectionPayload) {
    if (!sectionPayload) return;

    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var itemsSectionId = itemsEl && itemsEl.dataset.id;
    var footerSectionId = footerEl && footerEl.dataset.id;

    if (itemsSectionId && sectionPayload[itemsSectionId]) {
      var cartItemsEl = document.querySelector('cart-items');
      if (cartItemsEl && typeof cartItemsEl.applyCartSectionHtml === 'function') {
        cartItemsEl.applyCartSectionHtml(sectionPayload, null);
      } else if (cartItemsEl && typeof cartItemsEl.renderCartSections === 'function') {
        cartItemsEl.renderCartSections({ sections: sectionPayload });
      } else {
        var itemsDoc = parseSectionHtml(sectionPayload[itemsSectionId]);
        var newContents = itemsDoc.querySelector('#main-cart-items .js-contents');
        var oldContents = document.querySelector('#main-cart-items .js-contents');
        if (newContents && oldContents) {
          oldContents.innerHTML = newContents.innerHTML;
        }
      }
    }

    if (footerSectionId && sectionPayload[footerSectionId]) {
      var footerDoc = parseSectionHtml(sectionPayload[footerSectionId]);
      var newFooter = footerDoc.getElementById('main-cart-footer');
      var oldBlocks = footerEl && footerEl.querySelector('.cart__blocks');
      var newBlocks = newFooter && newFooter.querySelector('.cart__blocks');

      if (oldBlocks && newBlocks) {
        oldBlocks.innerHTML = newBlocks.innerHTML;
      }

      if (footerEl && newFooter) {
        footerEl.classList.toggle('is-empty', newFooter.classList.contains('is-empty'));
      }
    }

    bind(document);
    scheduleExpressMount();
  }

  function requestCartSections() {
    var cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl && typeof cartItemsEl.refreshCartSectionsFromServer === 'function') {
      return cartItemsEl.refreshCartSectionsFromServer().then(function () {
        bind(document);
        scheduleExpressMount();
      });
    }

    var sectionIds = getSectionIds();
    if (!sectionIds.length) return Promise.resolve();

    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';

    return fetch(
      cartUrl + '?sections=' + encodeURIComponent(sectionIds.join(',')) + '&sections_url=' + encodeURIComponent(window.location.pathname),
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    )
      .then(function (response) {
        if (!response.ok) throw new Error('section fetch failed');
        return response.json();
      })
      .then(function (data) {
        renderCartSections(data.sections || data);
      });
  }

  function updateCart(payload) {
    return postCartUpdate(Object.assign({}, payload, buildSectionRequest()))
      .then(function (data) {
        if (data && data.sections) {
          renderCartSections(data.sections);
          return data;
        }

        return requestCartSections().then(function () {
          return data;
        });
      });
  }

  function normalizePromoCode(code) {
    return String(code || '').trim().toUpperCase();
  }

  function fetchCart() {
    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';

    return fetch(cartUrl + '.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('cart fetch failed');
      return response.json();
    });
  }

  function cartHasFirst30Discount(cart) {
    if (!cart) return false;

    if ((cart.cart_level_discount_applications || []).some(function (discount) {
      return normalizePromoCode(discount.title).indexOf('FIRST30') !== -1;
    })) {
      return true;
    }

    return (cart.items || []).some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (allocation) {
        var title = allocation.discount_application && allocation.discount_application.title;
        return normalizePromoCode(title).indexOf('FIRST30') !== -1;
      });
    });
  }

  function cartHasDiscountCode(cart, code) {
    if (!cart) return false;
    var normalized = normalizePromoCode(code);

    if ((cart.discount_codes || []).some(function (entry) {
      if (entry.applicable === false) return false;
      return normalizePromoCode(entry.code) === normalized;
    })) {
      return true;
    }

    if ((cart.cart_level_discount_applications || []).some(function (discount) {
      return normalizePromoCode(discount.title) === normalized;
    })) {
      return true;
    }

    return (cart.items || []).some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (allocation) {
        var title = allocation.discount_application && allocation.discount_application.title;
        return normalizePromoCode(title) === normalized;
      });
    });
  }

  function isLensReplacementCartOrder(scope) {
    var cartItems = document.querySelector('cart-items');
    if (cartItems && cartItems.getAttribute('data-ciw-lr-order') === '1') return true;
    var summary = (scope || document).querySelector('[data-ciw-cart-summary]');
    return summary && summary.getAttribute('data-ciw-lr-order') === 'true';
  }

  function cartHasRelens20Discount(cart) {
    return cartHasDiscountCode(cart, 'RELENS20');
  }

  function removeCartDiscount() {
    window.__ciwFirst30AutoApplyBlocked = true;

    return clearShopifyDiscount()
      .then(function () {
        return updateCart({
          attributes: { ciw_first30_dismissed: '1' }
        });
      })
      .then(function (cart) {
        window.ciwFirst30Dismissed = true;
        return cart;
      });
  }

  function applyFirst30() {
    if (isContactsCartOrder()) {
      return Promise.reject(new Error('invalid discount'));
    }

    window.__ciwFirst30AutoApplyBlocked = false;

    return fetchCart().then(function (cart) {
      if (cartHasFirst30Discount(cart)) {
        return updateCart({ attributes: { ciw_first30_dismissed: '' } }).then(function (updatedCart) {
          window.ciwFirst30Dismissed = false;
          return updatedCart;
        });
      }

      return hitDiscountUrl('/discount/FIRST30')
        .then(function () {
          return delay(350);
        })
        .then(function () {
          return fetchCart();
        })
        .then(function (freshCart) {
          if (!cartHasFirst30Discount(freshCart)) throw new Error('invalid discount');
          return updateCart({ attributes: { ciw_first30_dismissed: '' } });
        })
        .then(function (updatedCart) {
          window.ciwFirst30Dismissed = false;
          return updatedCart;
        });
    });
  }

  function applyOtherDiscount(code) {
    return hitDiscountUrl('/discount/' + encodeURIComponent(code))
      .then(function () {
        return delay(350);
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        if (!cartHasDiscountCode(cart, code)) throw new Error('invalid discount');
        return requestCartSections().then(function () {
          return cart;
        });
      });
  }

  function applyRelens20(scope) {
    if (!isLensReplacementCartOrder(scope)) {
      return Promise.reject(new Error('invalid discount'));
    }
    return fetchCart().then(function (cart) {
      if (cartHasRelens20Discount(cart)) {
        return requestCartSections().then(function () { return cart; });
      }
      return Promise.reject(new Error('relens20-auto'));
    });
  }

  function applyCartDiscount(code, scope) {
    var normalized = normalizePromoCode(code);
    if (!normalized) return Promise.reject(new Error('empty'));

    if (normalized === 'CONTACTS20' && isContactsCartOrder(scope)) {
      return Promise.resolve();
    }

    if (normalized === 'RELENS20' && isLensReplacementCartOrder(scope)) {
      return applyRelens20(scope);
    }

    if (normalized === 'FIRST30') {
      return applyFirst30();
    }

    return applyOtherDiscount(code);
  }

  function setPromoError(message) {
    var errorEl = document.querySelector('[data-ciw-promo-error]');
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function isContactsCartOrder(scope) {
    var summary = (scope || document).querySelector('[data-ciw-cart-summary]');
    return summary && summary.getAttribute('data-ciw-contacts-order') === 'true';
  }

  function bindPromoControls(root) {
    if (!mq.matches) return;

    var scope = root || document;
    var applyBtn = scope.querySelector('[data-ciw-promo-apply]');
    var removeBtn = scope.querySelector('[data-ciw-promo-remove]');
    var input = scope.querySelector('[data-ciw-promo-input]');

    if (applyBtn && !applyBtn.dataset.ciwPromoBound) {
      applyBtn.dataset.ciwPromoBound = 'true';
      applyBtn.addEventListener('click', function (event) {
        event.preventDefault();
        if (!input) return;
        var code = input.value.trim();
        if (!code) {
          setPromoError('Enter a promo code.');
          return;
        }

        if (normalizePromoCode(code) === 'CONTACTS20' && isContactsCartOrder(scope)) {
          setPromoError('');
          input.value = '';
          return;
        }

        if (normalizePromoCode(code) === 'RELENS20' && isLensReplacementCartOrder(scope)) {
          setPromoError('');
          applyBtn.disabled = true;
          applyRelens20(scope)
            .then(function () {
              setPromoError('');
              if (input) input.value = '';
            })
            .catch(function () {
              setPromoError('RELENS20 applies automatically at checkout on lens replacement orders.');
            })
            .finally(function () {
              applyBtn.disabled = false;
            });
          return;
        }

        setPromoError('');
        applyBtn.disabled = true;

        applyCartDiscount(code, scope)
          .then(function () {
            setPromoError('');
            if (input) input.value = '';
          })
          .catch(function () {
            if (normalizePromoCode(code) === 'FIRST30' && isContactsCartOrder(scope)) {
              setPromoError('FIRST30 code is for glasses/sunglasses only. Restrictions apply.');
              return;
            }
            if (normalizePromoCode(code) === 'RELENS20' && isLensReplacementCartOrder(scope)) {
              setPromoError('RELENS20 applies automatically at checkout on lens replacement orders.');
              return;
            }
            setPromoError('Invalid code. Please try again.');
          })
          .finally(function () {
            applyBtn.disabled = false;
          });
      });
    }

    if (input && !input.dataset.ciwPromoBound) {
      input.dataset.ciwPromoBound = 'true';
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          if (applyBtn) applyBtn.click();
        }
      });
    }

    if (removeBtn && !removeBtn.dataset.ciwPromoBound) {
      removeBtn.dataset.ciwPromoBound = 'true';
      removeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (removeBtn.hasAttribute('data-ciw-promo-remove-locked')) {
          setPromoError('No, we refuse for you to pay more.');
          return;
        }

        removeBtn.disabled = true;
        setPromoError('');

        removeCartDiscount()
          .then(function () {
            if (input) input.value = '';
          })
          .catch(function () {
            return requestCartSections().catch(function () {
              window.location.reload();
            });
          })
          .finally(function () {
            removeBtn.disabled = false;
          });
      });
    }
  }

  function getLaRequiredCartFields(items) {
    return items.map(function (item) {
      return {
        id: item.id,
        quantity: item.quantity,
        variant_id: item.variant_id,
        properties: item.properties,
        key: item.key,
        vendor: item.vendor
      };
    });
  }

  function syncLensAdvizorCartCache(items) {
    if (!items || !items.length) return;
    try {
      var json = JSON.stringify(getLaRequiredCartFields(items));
      localStorage.setItem('_la_cart', json);
      localStorage.setItem('_la_prev_cart_req', json);
    } catch (e) {}
  }

  function bumpLensAdvizorCacheQuantity(lineKey, quantity) {
    if (!lineKey) return;
    try {
      var raw = localStorage.getItem('_la_cart');
      if (!raw) return;
      var items = JSON.parse(raw);
      var changed = false;
      items.forEach(function (item) {
        if (item.key === lineKey) {
          item.quantity = quantity;
          changed = true;
        }
      });
      if (changed) syncLensAdvizorCartCache(items);
    } catch (e) {}
  }

  function updateContactCartQuantity(cartItems, input, quantity, focusName) {
    var lineKey = input.getAttribute('data-line-key');
    var line = input.dataset.index;
    var changeUrl = (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change';

    if (!lineKey || !cartItems || typeof cartItems.getSectionsToRender !== 'function') {
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        cartItems.updateQuantity(lineKey || line, quantity, focusName || '', input.dataset.quantityVariantId, line);
      }
      return;
    }

    cartItems.enableLoading(line);
    window.__ciwContactQtyUpdating = true;
    bumpLensAdvizorCacheQuantity(lineKey, quantity);

    var body = JSON.stringify({
      id: lineKey,
      quantity: quantity,
      sections: cartItems.getSectionsToRender().map(function (section) {
        return section.section;
      }),
      sections_url: window.location.pathname
    });

    var config = typeof fetchConfig === 'function'
      ? fetchConfig()
      : {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        };

    fetch(changeUrl, Object.assign({}, config, { body: body }))
      .then(function (response) {
        return response.text();
      })
      .then(function (state) {
        var parsedState = JSON.parse(state);
        var quantityElement = document.getElementById('Quantity-' + line) || input;

        if (parsedState.errors) {
          if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
          if (typeof cartItems.updateLiveRegions === 'function') {
            cartItems.updateLiveRegions(line, parsedState.errors);
          }
          if (parsedState.items) syncLensAdvizorCartCache(parsedState.items);
          return;
        }

        if (parsedState.items) syncLensAdvizorCartCache(parsedState.items);

        var visuallyEmpty =
          typeof cartItems.isCartVisuallyEmpty === 'function'
            ? cartItems.isCartVisuallyEmpty(parsedState)
            : parsedState.item_count === 0;

        cartItems.classList.toggle('is-empty', visuallyEmpty);
        var cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', visuallyEmpty);

        if (typeof cartItems.renderCartSections === 'function') {
          cartItems.renderCartSections(parsedState);
        } else {
          cartItems.getSectionsToRender().forEach(function (section) {
            var sectionRoot = document.getElementById(section.id);
            if (!sectionRoot || !parsedState.sections || !parsedState.sections[section.section]) return;
            var elementToReplace = sectionRoot.querySelector(section.selector) || sectionRoot;
            elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items',
            cartData: parsedState,
            variantId: input.dataset.quantityVariantId
          });
        }
      })
      .catch(function () {
        if (input) input.value = input.getAttribute('value');
        var errors = document.getElementById('cart-errors');
        if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
      })
      .finally(function () {
        window.__ciwContactQtyUpdating = false;
        cartItems.disableLoading(line);
      });
  }

  function bindContactQtySteppers(root) {
    if (!mq.matches) return;

    (root || document).querySelectorAll('[data-ciw-cl-qty-stepper]:not([data-ciw-cl-qty-bound])').forEach(function (stepper) {
      stepper.setAttribute('data-ciw-cl-qty-bound', 'true');

      var input = stepper.querySelector('.cl-eye-row__step-input');
      var display = stepper.querySelector('[data-ciw-cl-qty-display]');
      var minus = stepper.querySelector('[data-ciw-cl-qty-minus]');
      var plus = stepper.querySelector('[data-ciw-cl-qty-plus]');
      if (!input) return;

      var cartItems = input.closest('cart-items');
      if (!cartItems || typeof cartItems.updateQuantity !== 'function') return;

      var min = parseInt(input.getAttribute('data-min') || input.getAttribute('min'), 10);
      if (isNaN(min) || min < 1) min = 1;
      var max = parseInt(input.getAttribute('data-max') || input.getAttribute('max'), 10);
      if (isNaN(max)) max = null;

      function formatBoxLabel(qty) {
        var n = parseInt(qty, 10);
        if (isNaN(n) || n < min) n = min;
        return n + (n === 1 ? ' Box' : ' Boxes');
      }

      function syncStepper() {
        var value = parseInt(input.value, 10);
        if (isNaN(value)) value = min;

        if (display) display.textContent = formatBoxLabel(value);
        if (minus) minus.disabled = value <= min;
        if (plus) plus.disabled = max !== null && value >= max;
      }

      function setValue(nextValue, focusName) {
        var value = parseInt(nextValue, 10);
        if (isNaN(value)) value = min;
        if (value < min) value = min;
        if (max !== null && value > max) value = max;

        var previous = parseInt(input.value, 10);
        if (previous === value) {
          syncStepper();
          return;
        }

        input.value = value;
        input.setAttribute('value', String(value));
        syncStepper();

        updateContactCartQuantity(cartItems, input, value, focusName || '');
      }

      if (minus) {
        minus.addEventListener('click', function (event) {
          event.preventDefault();
          var value = parseInt(input.value, 10) || min;
          setValue(value - 1, 'minus');
        });
      }

      if (plus) {
        plus.addEventListener('click', function (event) {
          event.preventDefault();
          var value = parseInt(input.value, 10) || min;
          setValue(value + 1, 'plus');
        });
      }

      syncStepper();
    });
  }

  var bindScheduled = null;

  function scheduleBind(root) {
    if (bindScheduled) window.cancelAnimationFrame(bindScheduled);
    bindScheduled = window.requestAnimationFrame(function () {
      bindScheduled = null;
      bind(root || document);
    });
  }

  function bind(root) {
    bindDetails(root);
    bindMenus(root);
    bindPromoControls(root);
    bindContactQtySteppers(root);
    bindRemoveConfirm(root);
    bindRemoveSheet();
    bindCheckoutSticky();
  }

  function mountExpressCheckout() {
    if (!document.body.classList.contains('template-cart')) return;

    var mobileMount = document.querySelector('[data-ciw-express-mount]');
    var desktopMount = document.querySelector('[data-ciw-express-desktop-mount]');
    var buttons = getExpressCheckoutButtons();

    if (!buttons) return;

    if (!mq.matches) {
      return;
    }

    if (mobileMount && !mobileMount.contains(buttons)) {
      var sidebarMount = document.querySelector('[data-ciw-express-sidebar-mount]');
      if (sidebarMount && sidebarMount.contains(buttons)) {
        mobileMount.appendChild(buttons);
        remountAcceleratedCheckoutCart(mobileMount);
        reinitExpressCheckout();
        updateCheckoutStickyState();
        return;
      }
    }

    if (desktopMount && desktopMount.contains(buttons) && mobileMount) {
      mobileMount.appendChild(buttons);
      window.__ciwExpressLocation = 'header';
      remountAcceleratedCheckoutCart(mobileMount);
      reinitExpressCheckout();
      updateCheckoutStickyState();
      return;
    }

    if (
      mobileMount &&
      mobileMount.contains(buttons) &&
      mobileMount.querySelector('shopify-accelerated-checkout-cart') &&
      !buttons.dataset.ciwExpressReady
    ) {
      buttons.dataset.ciwExpressReady = '1';
      reinitExpressCheckout();
    }

    updateCheckoutStickyState();
  }

  function maybeAutoApplyFirst30() {
    if (window.__ciwFirst30AutoApplyBlocked) return;
    if (!document.body.classList.contains('template-cart')) return;
    if (isContactsCartOrder()) return;

    fetchCart().then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) return;
      if (cart.attributes && cart.attributes.ciw_first30_dismissed === '1') return;
      if (cartHasFirst30Discount(cart)) return;
      applyFirst30().catch(function () {});
    });
  }

  function guardLensAdvizorCartReload() {
    if (window.__ciwLaCartReloadGuard || !document.body.classList.contains('template-cart')) return;
    window.__ciwLaCartReloadGuard = true;
    var nativeReload = window.location.reload.bind(window.location);
    window.location.reload = function () {
      if (window.__ciwContactQtyUpdating) return;
      return nativeReload.apply(window.location, arguments);
    };
  }

  function init() {
    guardLensAdvizorCartReload();
    bind(document);
    scheduleExpressMount();
    maybeAutoApplyFirst30();
    document.addEventListener('ciw:cart-dom-updated', function () {
      bind(document);
      scheduleExpressMount();
      updateCheckoutStickyState();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && !window.__ciwCartMobileUpdateBound) {
      window.__ciwCartMobileUpdateBound = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || event.source !== 'cart-items') return;
        bind(document);
        if (event.cartData) {
          var visuallyEmpty =
            window.CIW_CART_SYNC && typeof window.CIW_CART_SYNC.countVisibleItems === 'function'
              ? window.CIW_CART_SYNC.countVisibleItems(event.cartData) === 0
              : event.cartData.item_count === 0;
          if (visuallyEmpty) {
            clearExpressMount();
          } else {
            scheduleExpressMount();
          }
        } else {
          scheduleExpressMount();
        }
      });
    }
    if (!window.__ciwLdCartMqBound) {
      window.__ciwLdCartMqBound = true;
      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', function () {
          document.querySelectorAll('.ciw-ld-cart-details').forEach(syncDetailsLabel);
          bind(document);
          bindCheckoutSticky();
        });
      }
    }
    if (!window.__ciwLdCartMenuDocBound) {
      window.__ciwLdCartMenuDocBound = true;
      document.addEventListener('click', function () {
        if (!mq.matches) return;
        closeAllMenus();
      });
      document.addEventListener('keydown', function (event) {
        if (!mq.matches || event.key !== 'Escape') return;
        if (getRemoveSheet() && getRemoveSheet().classList.contains('is-open')) {
          closeRemoveSheet();
          return;
        }
        closeAllMenus();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });

  var cartItems = document.querySelector('cart-items');
  if (cartItems && typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function () {
      scheduleBind(cartItems);
    });
    observer.observe(cartItems, { childList: true, subtree: true });
  }

  var cartFooter = document.getElementById('main-cart-footer');
  if (cartFooter && typeof MutationObserver !== 'undefined') {
    var footerObserver = new MutationObserver(function () {
      scheduleBind(document);
      if (mq.matches) scheduleExpressMount();
    });
    footerObserver.observe(cartFooter, { childList: true, subtree: true });
  }
})();
